import { IconBell } from '@tabler/icons-react';
import { Switch, WP_ICON_NAV } from '@wapharma/design-system';
import { useNotificationSoundPref } from '../hooks/useNotificationSoundPref';
import styles from './NotificationSoundAccountToggle.module.css';

export function NotificationSoundAccountToggle() {
  const { soundEnabled, setSoundEnabled } = useNotificationSoundPref();

  return (
    <div className={styles.row}>
      <span className={styles.iconSlot} aria-hidden>
        <IconBell {...WP_ICON_NAV} className={styles.icon} />
      </span>
      <Switch className={styles.switch} checked={soundEnabled} onChange={(e) => setSoundEnabled(e.currentTarget.checked)} />
      <span className={styles.label}>Son des notifications</span>
    </div>
  );
}
